<template>
  <div v-if="result && Object.keys(result).length" class="search-top-response">
    <div class="search-block">
      <SearchHistory :result="result" @select="$emit('selectSuggest', $event)" />

      <div v-if="result?.suggest" class="search-response">
        <h6 class="search-response__title">
          {{ result.messages?.popularQueriesTitle }}
        </h6>
        <SearchSuggests :result="result?.suggest" @selectSuggest="$emit('selectSuggest', $event)" />
      </div>

      <div v-if="result?.sections?.length > 0" class="search-response">
        <h6 class="search-response__title">{{ result.messages.sectionsTitle }}</h6>
        <div class="search-response-items">
          <a
            v-for="{ url, name, ID } in result.sections"
            :key="ID"
            class="search-response-items__item"
            :href="url"
          >
            {{ name }}
          </a>
        </div>
      </div>

      <div v-if="result?.collections?.length > 0" class="search-response">
        <h6 class="search-response__title">{{ result.messages.collectionsTitle }}</h6>
        <div class="search-response-items">
          <a
            v-for="{ url, name, id } in result.collections"
            :key="id"
            class="search-response-items__item"
            :href="url"
          >
            {{ name }}
          </a>
        </div>
      </div>
    </div>
    <div v-if="result?.products?.items" class="search-response-products">
      <h6 class="search-response-products__title">
        {{ result?.query ? result.messages.productsTitle : result.messages.itemsTitle }}
      </h6>
      <div class="search-response-products__items">
        <SearchProduct
          v-for="item in result.products.items"
          :key="item?.offer?.id ?? item.id"
          :result="item"
        />
      </div>
      <div v-if="result.url && screenWidth >= 992" class="search-response-bottom">
        <span v-if="result?.printQuantity" class="search-response-bottom__text">{{
          result?.printQuantity
        }}</span>
        <DefButtonPrimary :href="result.url"> {{ result?.messages?.allResults }}</DefButtonPrimary>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ISearchResponse } from '@components/Search/ISearch';
import SearchSuggests from '@components/Search/SearchSuggests.vue';
import SearchHistory from '@components/Search/SearchHistory.vue';
import SearchProduct from '@components/Search/SearchProduct.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import useScreenWidth from '@use/useScreenWidth';

const props = defineProps<{ result?: ISearchResponse }>();

const screenWidth = useScreenWidth();
</script>

<style lang="scss" scoped>
.search-top-response {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-row-gap: 24px;
  margin-bottom: 24px;
  @include point-lg {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-bottom: 32px;
    margin-right: 52px;
  }
  .search-response-items,
  :deep(.search-suggests) {
    display: grid;
    grid-row-gap: 12px;
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
  }
}
.search-block {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-row-gap: 24px;
  @include point-md {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-column-gap: 32px;
  }
}
.search-response {
  &__title {
    color: var(--color-dark-grey);
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    text-transform: uppercase;
    margin-bottom: 14px;
  }
}
.search-response-products {
  &__title {
    color: var(--color-dark-grey);
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    text-transform: uppercase;
    margin-bottom: 14px;
  }
  &__items {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-row-gap: 8px;
  }
}
.search-response-items {
  &__item {
    &:hover {
      text-decoration: underline;
      text-underline-position: under;
    }
  }
}
.search-response-bottom {
  display: flex;
  align-items: center;
  width: max-content;
  margin: 16px auto 0;
  &__text {
    margin-right: 12px;
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    color: var(--color-dark-grey);
  }
}
</style>
